@use 'config' as config;

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

:host {
  display: grid;
  position: relative;
  grid-auto-columns: 1fr;
  grid-auto-flow: column dense;
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  gap: config.$image-gallery-gap;
  aspect-ratio: 3 / 1;
  overflow: hidden;
  border: config.$image-gallery-border-width solid transparent;

  .close-button {
    position: absolute;
    z-index: 1;
    top: 1rem;
    right: 1rem;
    animation: fade-in 0.5s 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    border: 0;
    background-color: transparent;
    cursor: pointer;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
}
